import translationEN from "locales/en-US/translation.json";
import translationES from "locales/es-ES/translation.json";

export const TRANSLATION_RESOURCES = {
  en: {
    translation: translationEN,
  },
  es: {
    translation: translationES,
  },
};

export const BRAND_DEFAULT_VARIABLES = {
  platformName: "",
  supportEmail: "support@outpave.com",
};
